var _g, _g2, _g3, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllPhones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 86,
    viewBox: "0 0 80 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.032897,
    y: 1.17682,
    width: 35.5878,
    height: 71.8,
    rx: 2.39333,
    transform: "matrix(-0.726589 0.687072 0.687072 0.726589 26.202 6.58801)",
    fill: "white",
    stroke: "#6BCE4C",
    strokeWidth: 1.66493
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.208116,
    x2: 8.33756,
    y2: -0.208116,
    transform: "matrix(-0.723371 0.69046 0.69046 0.723371 21.6597 15.3672)",
    stroke: "#6BCE4C",
    strokeWidth: 0.416232
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.208116,
    y1: -0.208116,
    x2: 2.14645,
    y2: -0.208116,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 13.5474 22.9971)",
    stroke: "#6BCE4C",
    strokeWidth: 0.416232,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_19_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.493458,
    y: 1.06887,
    width: 35.5878,
    height: 71.8,
    rx: 2.39333,
    transform: "matrix(-0.938378 0.34561 0.34561 0.938378 52.2839 0.23641)",
    fill: "white",
    stroke: "#6BCE4C",
    strokeWidth: 1.66493
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.208116,
    x2: 9.83653,
    y2: -0.208116,
    transform: "matrix(-0.941507 0.336993 0.336993 0.941507 48.8232 4.99463)",
    stroke: "#6BCE4C",
    strokeWidth: 0.416232
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.208116,
    x2: 7.86791,
    y2: -0.208116,
    transform: "matrix(-0.939019 0.343866 0.343866 0.939019 34.1509 10.1978)",
    stroke: "#6BCE4C",
    strokeWidth: 0.416232
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0765 34.2349L29.5777 40.974",
    stroke: "#6BCE4C",
    strokeWidth: 1.9771,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_19_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.832464,
    y: 0.832464,
    width: 35.5878,
    height: 71.8,
    rx: 2.39333,
    transform: "matrix(-1 0 0 1 75.878 4.16211)",
    fill: "white",
    stroke: "#6BCE4C",
    strokeWidth: 1.66493
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.208116,
    x2: 16.9614,
    y2: -0.208116,
    transform: "matrix(-1 0 0 1 67.3452 7.07568)",
    stroke: "#6BCE4C",
    strokeWidth: 0.416232
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.416232,
    cy: 0.416232,
    r: 0.416232,
    transform: "matrix(-1 0 0 1 14.5879 21.748)",
    fill: "#6BCE4C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_45",
    x: 1.33447,
    y: 7.57812,
    width: 76.374,
    height: 77.8052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_45",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_19_45",
    x: 19.5679,
    y: 0.915039,
    width: 60.0171,
    height: 81.4824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_45",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_19_45",
    x: 40.29,
    y: 4.16211,
    width: 38.7529,
    height: 74.9648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_45",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPhones);
export default __webpack_public_path__ + "static/media/all-phones.711a5d91bda15972682fc7418bdaa768.svg";
export { ForwardRef as ReactComponent };